import { favouritesConstants, fixedDepositsConstants } from "../_constants";

export const getFavouritesListRequest = (payload) => {
  return {
    type: favouritesConstants.GET_FAVOURITES_LIST_REQUEST,
    payload,
  };
};

export const getFavouritesListComplete = (payload) => {
  return {
    type: favouritesConstants.GET_FAVOURITES_LIST_COMPLETE,
    payload,
  };
};

export const getFavouritesListError = (payload) => {
  return {
    type: favouritesConstants.GET_FAVOURITES_LIST_ERROR,
    payload,
  };
};

export const getFavouritesDetailsRequest = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_DETAILS_REQUEST,
    payload,
  };
};

export const getFavouritesDetailsComplete = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_DETAILS_COMPLETE,
    payload,
  };
};

export const getFavouritesDetailsError = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_DETAILS_ERROR,
    payload,
  };
};

export const getRecentFavouritesListRequest = (payload) => {
  return {
    type: favouritesConstants.GET_RECENT_FAVOURITES_LIST_REQUEST,
    payload,
  };
};

export const getRecentFavouritesListComplete = (payload) => {
  return {
    type: favouritesConstants.GET_RECENT_FAVOURITES_LIST_COMPLETE,
    payload,
  };
};

export const getRecentFavouritesListError = (payload) => {
  return {
    type: favouritesConstants.GET_RECENT_FAVOURITES_LIST_ERROR,
    payload,
  };
};

export const addToFavouritesRequest = (payload) => {
  return {
    type: favouritesConstants.ADD_TO_FAVOURITES_REQUEST,
    payload,
  };
};

export const addToFavouritesComplete = (payload) => {
  return {
    type: favouritesConstants.ADD_TO_FAVOURITES_COMPLETE,
    payload,
  };
};

export const addToFavouritesError = (payload) => {
  return {
    type: favouritesConstants.ADD_TO_FAVOURITES_ERROR,
    payload,
  };
};

export const clearAddToFavourites = () => {
  return {
    type: favouritesConstants.CLEAR_ADD_TO_FAVOURITE_CONFIRMATION,
  };
};

export const setSelectedFavourite = (payload) => {
  return {
    type: favouritesConstants.SET_SELECTED_FAVOURITE,
    payload,
  };
};

export const setFavouriteScreenType = (payload) => {
  return {
    type: favouritesConstants.SET_FAVOURITE_SCREEN_TYPE,
    payload,
  };
};

export const setFavouritesActiveTab = (payload) => {
  return {
    type: favouritesConstants.SET_FAVOURITES_ACTIVE_TAB,
    payload,
  };
};

export const setFavouriteFormTabType = (payload) => {
  return {
    type: favouritesConstants.SET_FORM_TAB_TYPE,
    payload,
  };
};

export const setFavouriteOtpConfirmationStatus = (payload) => {
  return {
    type: favouritesConstants.SET_OTP_CONFIRNATION_STATUS,
    payload,
  };
};

export const setFavouritesSelectedPaymentOption = (payload) => {
  return {
    type: favouritesConstants.SET_FAVOURITE_SELECTED_PAYMENT_OPTION,
    payload,
  };
};

export const payableFavouritesListRequest = (payload) => {
  return {
    type: favouritesConstants.FAVOURITES_PAYABLE_LIST_REQUEST,
    payload,
  };
};

export const payableFavouritesListComplete = (payload) => {
  return {
    type: favouritesConstants.FAVOURITES_PAYABLE_LIST_COMPLETE,
    payload,
  };
};

export const payableFavouritesListError = (payload) => {
  return {
    type: favouritesConstants.FAVOURITES_PAYABLE_LIST_ERROR,
    payload,
  };
};

export const setFavouritesPayableAcccounts = (payload) => {
  return {
    type: favouritesConstants.SET_FAVOURITE_PAYABE_ACCOUNTS,
    payload,
  };
};

export const setFavouritesPayableCards = (payload) => {
  return {
    type: favouritesConstants.SET_FAVOURITE_PAYABE_CARDS,
    payload,
  };
};

export const setFavouriteAmount = (payload) => {
  return {
    type: favouritesConstants.SET_FAVOURITE_AMOUNT,
    payload,
  };
};

export const setFavouriteOutstandingAmount = (payload) => {
  return {
    type: favouritesConstants.SET_FAVOURITE_OUTSTANDING_AMOUNT,
    payload,
  };
};

export const setFavouritePayAccountNumber = (payload) => {
  return {
    type: favouritesConstants.SET_FAVOURITE_PAY_ACCOUNT_NUMBER,
    payload,
  };
};

export const setFavouriteCardType = (payload) => {
  return {
    type: favouritesConstants.SET_FAVOURITE_CARD_TYPE,
    payload,
  };
};

export const setFavouritePayBalance = (payload) => {
  return {
    type: favouritesConstants.SET_FAVOURITE_PAY_BALANCE,
    payload,
  };
};

export const setFavouritePayStatus = (payload) => {
  return {
    type: favouritesConstants.SET_FAVOURITE_PAYMENT_STATUS,
    payload,
  };
};

export const clearFavouriteAmountValidationStatus = (payload) => {
  return {
    type: favouritesConstants.CLEAR_FAVOURITE_AMOUNT_VALIDATION_STATUS,
    payload,
  };
};

export const validateFavouriteAmountRequest = (payload) => {
  return {
    type: favouritesConstants.VALIDATE_FAVOURITE_AMOUNT_REQUEST,
    payload,
  };
};

export const validateFavouriteAmountComplete = (payload) => {
  return {
    type: favouritesConstants.VALIDATE_FAVOURITE_AMOUNT_COMPLETE,
    payload,
  };
};

export const validateFavouriteAmountError = (payload) => {
  return {
    type: favouritesConstants.VALIDATE_FAVOURITE_AMOUNT_ERROR,
    payload,
  };
};

export const payFavouriteRequest = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_PAY_BILL_REQUEST,
    payload,
  };
};

export const payFavouriteError = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_PAY_BILL_ERROR,
    payload,
  };
};

export const payFavouriteComplete = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_PAY_BILL_COMPLETE,
    payload,
  };
};

export const favouriteOutStadingAmountRequest = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_OUTSTANDING_AMOUNT_REQUEST,
    payload,
  };
};

export const favouriteOutStadingAmountComplete = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_OUTSTANDING_AMOUNT_COMPLETE,
    payload,
  };
};

export const favouriteOutStadingAmountError = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_OUTSTANDING_AMOUNT_ERROR,
    payload,
  };
};

export const tryAgainFavouritePayment = () => {
  return {
    type: favouritesConstants.TRY_AGAIN_FAVOURITE_PAYMENT,
  };
};

export const clearFavourite = () => {
  return {
    type: favouritesConstants.CLEAR_FAVOURITE,
  };
};

export const updateFavouriteRequest = (payload) => {
  return {
    type: favouritesConstants.UPDATE_FAVOURITE_REQUEST,
    payload,
  };
};

export const updateFavouriteComplete = (payload) => {
  return {
    type: favouritesConstants.UPDATE_FAVOURITE_COMPLETE,
    payload,
  };
};

export const updateFavouriteError = (payload) => {
  return {
    type: favouritesConstants.UPDATE_FAVOURITE_ERROR,
    payload,
  };
};

export const deleteFavouriteRequest = (payload) => {
  return {
    type: favouritesConstants.DELETE_FAVOURITE_REQUEST,
    payload,
  };
};

export const deleteFavouriteComplete = (payload) => {
  return {
    type: favouritesConstants.DELETE_FAVOURITE_COMPLETE,
    payload,
  };
};

export const deleteFavouriteError = (payload) => {
  return {
    type: favouritesConstants.DELETE_FAVOURITE_ERROR,
    payload,
  };
};

export const setSelectedNavigationPathName = (payload) => {
  return {
    type: favouritesConstants.SET_SELECTED_PATH_NAME,
    payload,
  };
};

export const setIsPaginatingFavourites = (payload) => {
  return {
    type: favouritesConstants.SET_IS_PAGINATING_FAVOURITES,
    payload,
  };
};

export const favouriteUpdateOtpConfirmationRequest = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_OTP_CONFIRMATION_REQUEST,
    payload,
  };
};
export const favouriteUpdateOtpConfirmationComplete = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_OTP_CONFIRMATION_COMPLETE,
    payload,
  };
};
export const favouriteUpdateOtpConfirmationError = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_OTP_CONFIRMATION_ERROR,
    payload,
  };
};

export const favouriteTransactionHistoryListRequest = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_TRANSACTION_HISTORY_LIST_REQUEST,
    payload,
  };
};

export const favouriteTransactionHistoryListComplete = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_TRANSACTION_HISTORY_LIST_COMPLETE,
    payload,
  };
};

export const favouriteTransactionHistoryDetailRequest = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_TRANSACTION_HISTORY_DETAIL_REQUEST,
    payload,
  };
};

export const favouriteTransactionHistoryDetailComplete = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_TRANSACTION_HISTORY_DETAIL_COMPLETE,
    payload,
  };
};

export const favouriteResendOtpRequest = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_OTP_RESEND_REQUEST,
    payload,
  };
};

export const favouriteResendOtpComplete = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_OTP_RESEND_COMPLETE,
    payload,
  };
};

export const favouriteResendOtpError = (payload) => {
  return {
    type: favouritesConstants.FAVOURITE_OTP_RESEND_ERROR,
    payload,
  };
};

export const clearFavouriteActiveTab = () => {
  return {
    type: favouritesConstants.CLEAR_FAVOURITE_ACTIVE_TAB,
  };
};

export const clearFavouritesList = () => {
  return {
    type: favouritesConstants.CLEAR_FAVOURITE_LIST,
  };
};